/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DestinationMetadata } from './DestinationMetadata';
import {
    DestinationMetadataFromJSON,
    DestinationMetadataFromJSONTyped,
    DestinationMetadataToJSON,
} from './DestinationMetadata';
import type { DestinationWithSecretsSecrets } from './DestinationWithSecretsSecrets';
import {
    DestinationWithSecretsSecretsFromJSON,
    DestinationWithSecretsSecretsFromJSONTyped,
    DestinationWithSecretsSecretsToJSON,
} from './DestinationWithSecretsSecrets';

/**
 * Destination object with secrets field (returned by getDestination when includeSecrets is true)
 * @export
 * @interface DestinationWithSecrets
 */
export interface DestinationWithSecrets {
    /**
     * The destination ID.
     * @type {string}
     * @memberof DestinationWithSecrets
     */
    id: string;
    /**
     * User-defined name for the destination.
     * @type {string}
     * @memberof DestinationWithSecrets
     */
    name: string;
    /**
     * The type of the destination.
     * @type {string}
     * @memberof DestinationWithSecrets
     */
    type: string;
    /**
     * 
     * @type {DestinationMetadata}
     * @memberof DestinationWithSecrets
     */
    metadata: DestinationMetadata;
    /**
     * The time the destination was created.
     * @type {Date}
     * @memberof DestinationWithSecrets
     */
    createTime: Date;
    /**
     * The time the destination was updated.
     * @type {Date}
     * @memberof DestinationWithSecrets
     */
    updateTime?: Date;
    /**
     * 
     * @type {DestinationWithSecretsSecrets}
     * @memberof DestinationWithSecrets
     */
    secrets?: DestinationWithSecretsSecrets;
}

/**
 * Check if a given object implements the DestinationWithSecrets interface.
 */
export function instanceOfDestinationWithSecrets(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "metadata" in value;
    isInstance = isInstance && "createTime" in value;

    return isInstance;
}

export function DestinationWithSecretsFromJSON(json: any): DestinationWithSecrets {
    return DestinationWithSecretsFromJSONTyped(json, false);
}

export function DestinationWithSecretsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DestinationWithSecrets {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'type': json['type'],
        'metadata': DestinationMetadataFromJSON(json['metadata']),
        'createTime': (new Date(json['createTime'])),
        'updateTime': !exists(json, 'updateTime') ? undefined : (new Date(json['updateTime'])),
        'secrets': !exists(json, 'secrets') ? undefined : DestinationWithSecretsSecretsFromJSON(json['secrets']),
    };
}

export function DestinationWithSecretsToJSON(value?: DestinationWithSecrets | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'type': value.type,
        'metadata': DestinationMetadataToJSON(value.metadata),
        'createTime': (value.createTime.toISOString()),
        'updateTime': value.updateTime === undefined ? undefined : (value.updateTime.toISOString()),
        'secrets': DestinationWithSecretsSecretsToJSON(value.secrets),
    };
}

